var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('StarsEffect'),_c('HeaderComponent',{attrs:{"currentPageYPosition":_vm.currentPageYPosition}}),_c('MainComponent',{on:{"currentSectionOnScroll":_vm.$_getCurrentSectionOnScroll}}),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }